<template>
  <Matter :hasFilterContact="true"/>
</template>

<script>
import Matter from '@/views/matters/Matters'
export default {
  name: "Matters",
  components:{Matter}
}
</script>
